"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("utils");
var combineLearningPanelUrl = function (url) { return "".concat((0, utils_1.getPlatformUrl)(), "/learning-panel").concat(url); };
exports.default = combineLearningPanelUrl;
